import {DestroyRef, Injectable, inject} from "@angular/core";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {EMPTY, combineLatest, switchMap, timer} from "rxjs";
import {SocketService} from "src/app/modules/shared/services/socket.service";
import {DiscussionVisibilityService} from "./discussion-visibility.service";

@Injectable()
export class DiscussionPresenceState {
  private readonly socket = inject(SocketService);
  private readonly visibility = inject(DiscussionVisibilityService);
  private readonly destroy = inject(DestroyRef);
  private started = false;
  private acknowledged = false;
  private generation = 0;
  private sentAt = -Infinity;

  start(threadId: string, onVisible: () => void): void {
    if (this.started) return;
    this.started = true;
    combineLatest([this.visibility.active$, this.socket.ready$])
      .pipe(
        switchMap(([active, ready]) => {
          this.generation++;
          this.acknowledged = false;
          this.sentAt = -Infinity;
          if (!active || !ready) {
            this.socket.emitPresence(threadId, false);
            return EMPTY;
          }
          return timer(0, 1000);
        }),
        takeUntilDestroyed(this.destroy)
      )
      .subscribe(() => {
        if (this.acknowledged && performance.now() - this.sentAt < 15000)
          return;
        this.sentAt = performance.now();
        const generation = this.generation;
        this.socket.emitPresence(threadId, true, (accepted) => {
          if (
            !accepted ||
            this.destroy.destroyed ||
            generation !== this.generation ||
            this.acknowledged
          )
            return;
          this.acknowledged = true;
          onVisible();
        });
      });
    this.destroy.onDestroy(() => this.socket.emitPresence(threadId, false));
  }
}
